var _linearGradient, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeassistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 0,
    y2: 48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20a4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007fff"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.7812 5.34375h2.8125v37.3125h-2.8125z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.375 1.03125h3.375v45.9375h-3.375z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.7812.84375h3.75v46.3125h-3.75z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.375.75h3.75v46.5h-3.75z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.1562.75h3.375v46.5h-3.375z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.0312.9375h3v46.125h-3z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.9062 1.03125h2.8125v45.9375h-2.8125z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.7812 1.21875h2.4375v45.5625h-2.4375z"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.0312 1.40625h2.0625v45.1875h-2.0625z"
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.71875 1.40625h2.0625v45.1875h-2.0625z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.40625 5.71875h2.0625v36.5625h-2.0625z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 41.25,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 36.9375,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 32.625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 28.3125,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 24,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 19.6875,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 15.375,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 11.0625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 6.75,
    opacity: 0.03,
    r: 1.40625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 41.25,
    opacity: 0.03,
    r: 1.59375
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 36.9375,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 32.625,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 28.3125,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 24,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 19.6875,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 15.375,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 11.0625,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 6.75,
    opacity: 0.03,
    r: 1.59375
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.40625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.59375
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 41.25,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 36.9375,
    opacity: 0.07,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 32.625,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 28.3125,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 24,
    opacity: 0.07,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 19.6875,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 15.375,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 11.0625,
    opacity: 0.05,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 6.75,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.59375
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 41.25,
    opacity: 0.05,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 36.9375,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 32.625,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 28.3125,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 24,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 19.6875,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 15.375,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 11.0625,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 6.75,
    opacity: 0.05,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.6875
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 41.25,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 36.9375,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 32.625,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 28.3125,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 24,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 19.6875,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 15.375,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 11.0625,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 6.75,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.6875
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 41.25,
    opacity: 0.07,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 36.9375,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 32.625,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 28.3125,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 24,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 19.6875,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 15.375,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 11.0625,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 6.75,
    opacity: 0.05,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 41.25,
    opacity: 0.05,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 36.9375,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 32.625,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 28.3125,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 24,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 19.6875,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 15.375,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 11.0625,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 6.75,
    opacity: 0.05,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.40625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 41.25,
    opacity: 0.05,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 36.9375,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 32.625,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 28.3125,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 24,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19.6875,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.375,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 11.0625,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 6.75,
    opacity: 0.05,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.21875
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 41.25,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 36.9375,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 32.625,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 28.3125,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 24,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 19.6875,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 15.375,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 11.0625,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 6.75,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.03125
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 41.25,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 36.9375,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 32.625,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 28.3125,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 24,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 19.6875,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 15.375,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 11.0625,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 6.75,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.03125
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 41.25,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 36.9375,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 32.625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 28.3125,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 24,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 19.6875,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 15.375,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 11.0625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 6.75,
    opacity: 0.03,
    r: 1.03125
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#53c0f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.3853 38h-11.9398c-.3699 0-.6633-.3-.6633-.6637v-11.4241h-2.98494c-.44009 0-.79726-.3574-.79726-.7977 0-.2106.08292-.4149.22961-.5616l16.05359-16.25533c.3891-.39569 1.0205-.39569 1.416-.00638l.0064.00638 8.3871 8.44353v-1.5636c0-.3702.2998-.6637.6634-.6637h2.7872c.3699 0 .6633.2999.6633.6637v5.7375l3.5654 3.6379c.3061.3127.3061.8232-.0128 1.1296-.1467.1468-.3508.2297-.5613.2297h-2.9913v11.4177c0 .3701-.2998.6637-.6633.6637h-11.9462l2.4875-2.4826h2.2961c.1786.4978.6506.8552 1.2118.8552.708 0 1.2884-.5744 1.2884-1.2828 0-.7085-.574-1.2828-1.2884-1.2828-.5612 0-1.0396.3574-1.2118.8552h-2.6533l-2.3089 2.3103v-2.8145l2.749-2.7507h4.4455c.1786.4978.6506.8552 1.2119.8552.7079 0 1.2883-.5744 1.2883-1.2828s-.574-1.2828-1.2883-1.2828c-.5613 0-1.0397.3574-1.2119.8552h-3.5845l2.5704-2.5656v-2.1444l1.8497-1.8445c.1658.083.3571.1277.5549.1277.7079 0 1.2883-.5744 1.2883-1.2828 0-.7085-.574-1.2828-1.2883-1.2828-.708 0-1.2884.5743-1.2884 1.2828 0 .1978.0446.3893.1275.5552l-1.2437 1.2381v-3.925c.4975-.1787.8611-.6509.8611-1.2126 0-.7084-.5741-1.2828-1.2884-1.2828-.708 0-1.2884.5744-1.2884 1.2828 0 .5617.3572 1.0339.861 1.2126v3.925l-1.2437-1.2445c.0829-.1659.1276-.3574.1276-.5552 0-.7084-.574-1.2828-1.2884-1.2828-.7143 0-1.2884.5744-1.2884 1.2828s.5741 1.2828 1.2884 1.2828c.1977 0 .3891-.0447.5549-.1277l1.8496 1.8445v1.787l-2.3152 2.3167v-1.6977c.4975-.1787.861-.6509.861-1.2126 0-.7084-.574-1.2828-1.2883-1.2828-.708 0-1.2884.5744-1.2884 1.2828 0 .5617.3572 1.0339.861 1.2126v2.5529l-2.143 2.1444v-12.5856l1.7604-1.7614c.1658.0829.3571.1276.5548.1276.708 0 1.2884-.5744 1.2884-1.2828s-.574-1.2828-1.2884-1.2828c-.7079 0-1.2883.5744-1.2883 1.2828 0 .1978.0446.3893.1275.5552l-1.5817 1.5828-1.5818-1.5828c.0829-.1659.1276-.3574.1276-.5552 0-.7084-.5741-1.2828-1.2884-1.2828-.708 0-1.2884.5744-1.2884 1.2828s.5741 1.2828 1.2884 1.2828c.1977 0 .3891-.0447.5549-.1276l1.7603 1.7614v8.9861l-3.087-3.0826v-2.4635c.4975-.1787.8611-.651.8611-1.2126 0-.7084-.574-1.2828-1.2884-1.2828-.708 0-1.2884.5744-1.2884 1.2828 0 .5616.3572 1.0339.8611 1.2126v1.6083l-2.4046-2.3997v-2.3805c.4975-.1787.8611-.651.8611-1.2126 0-.7084-.574-1.2828-1.2884-1.2828-.708 0-1.2884.5744-1.2884 1.2828 0 .5616.3572 1.0339.8611 1.2126v2.7379l2.6533 2.6486h-1.5244c-.1786-.4978-.6506-.8552-1.2118-.8552-.708 0-1.2884.5744-1.2884 1.2828s.574 1.2828 1.2884 1.2828c.5612 0 1.0396-.3574 1.2118-.8552h2.3854l3.6929 3.6889v6.414l-1.9708-1.9721v-2.4699c.4975-.1787.861-.6509.861-1.2126 0-.7084-.574-1.2828-1.2883-1.2828-.708 0-1.2884.5744-1.2884 1.2828 0 .5617.3572 1.0339.861 1.2126v1.6083l-2.8701-2.8655c.0829-.166.1276-.3574.1276-.5553 0-.7084-.5741-1.2828-1.2884-1.2828-.708 0-1.2884.5744-1.2884 1.2828s.574 1.2828 1.2884 1.2828c.1977 0 .389-.0446.5549-.1276l2.8701 2.8656h-1.5244c-.1785-.4978-.6505-.8552-1.2118-.8552-.708 0-1.2884.5744-1.2884 1.2828s.5741 1.2828 1.2884 1.2828c.5613 0 1.0396-.3574 1.2118-.8552h2.3855zm-6.6013-19.1145c-.287 0-.5166.2298-.5166.517 0 .2808.2296.5169.5166.5169s.5166-.2297.5166-.5169-.2296-.517-.5166-.517zm3.2592 3.1719c-.287 0-.5166.2298-.5166.517 0 .2808.2296.5169.5166.5169s.5166-.2297.5166-.5169-.2296-.517-.5166-.517zm1.2054-5.144c-.287 0-.5166.2298-.5166.517s.2296.5169.5166.5169c.2871 0 .5167-.2297.5167-.5169s-.236-.517-.5167-.517zm11.7549 6.4268c.287 0 .5166-.2297.5166-.5169s-.2296-.517-.5166-.517c-.2871 0-.5167.2298-.5167.517s.2296.5169.5167.5169zm-6.2633-5.3992c.287 0 .5166-.2298.5166-.517s-.2296-.5169-.5166-.5169-.5167.2297-.5167.5169.2297.517.5167.517zm.5995 4.3717c-.287 0-.5166.2298-.5166.517s.2296.5169.5166.5169.5166-.2297.5166-.5169-.236-.517-.5166-.517zm-11.0723 3.5995c-.2871 0-.5167.2298-.5167.517 0 .2808.2296.517.5167.517.287 0 .5166-.2298.5166-.517s-.2296-.517-.5166-.517zm16.5638 5.5716c.2871 0 .5167-.2297.5167-.5169s-.2296-.517-.5167-.517c-.287 0-.5166.2298-.5166.517s.2296.5169.5166.5169zm-2.6596-12.5089c-.287 0-.5166.2297-.5166.5169 0 .2808.2296.517.5166.517s.5166-.2298.5166-.517c-.0064-.2872-.236-.5169-.5166-.5169zm-3.1763 7.5373c-.287 0-.5166.2297-.5166.5169s.2296.517.5166.517.5166-.2298.5166-.517-.2296-.5169-.5166-.5169zm-10.2942 3.6888c-.287 0-.5167.2298-.5167.517 0 .2808.2297.5169.5167.5169s.5166-.2297.5166-.5169c-.0064-.2872-.236-.517-.5166-.517zm.6824 4.4548c-.287 0-.5166.2297-.5166.5169 0 .2808.2296.517.5166.517s.5166-.2298.5166-.517-.2296-.5169-.5166-.5169zm13.2154.9445c.287 0 .5166-.2297.5166-.5169 0-.2808-.2296-.517-.5166-.517s-.5166.2298-.5166.517.2296.5169.5166.5169zm-9.4396-4.7993c-.287 0-.5166.2297-.5166.5169 0 .2808.2296.517.5166.517.2871 0 .5167-.2298.5167-.517s-.2296-.5169-.5167-.5169z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeassistant);
export default __webpack_public_path__ + "static/media/homeassistant.61cd67de9836b2a2e00b06e4019de7d4.svg";
export { ForwardRef as ReactComponent };